// const API_BASE_URL = "http://localhost:5000";
// const API_BASE_URL = "https://devapi.pretriptruck.com";
const API_BASE_URL = "https://api.pretriptruck.com";

const AppConstants: any = {
  ADMIN_LOGIN_API: `${API_BASE_URL}/admin/login`,
  ADMIN_VERIFY_OTP_API: `${API_BASE_URL}/admin/verify-otp`,
  ADMIN_RESEND_OTP_API: `${API_BASE_URL}/admin/resend-otp`,
  ADMIN_PROFILE_API: `${API_BASE_URL}/admin/get-profile`,
  ADMIN_EDIT_PROFILE_API: `${API_BASE_URL}/admin/edit-profile`,
  ADMIN_CHANGE_PASSWORD_API: `${API_BASE_URL}/admin/change-password`,

  ADMIN_GET_PROMOCODES_API: `${API_BASE_URL}/promocodes`,
  ADMIN_GET_SINGLE_PROMOCODE_API: `${API_BASE_URL}/promocodes`,
  ADMIN_CREATE_PROMOCODE_API: `${API_BASE_URL}/promocodes`,
  ADMIN_UPDATE_PROMOCODE_API: `${API_BASE_URL}/promocodes`,
  ADMIN_DELETE_PROMOCODE_API: `${API_BASE_URL}/promocodes`,

  ADMIN_GET_PRICES_API: `${API_BASE_URL}/iap/pricing`,
  ADMIN_EDIT_PRICES_API: `${API_BASE_URL}/pricing/bulk`,

  ADMIN_GET_PLAN_DETAILS_API: `${API_BASE_URL}/plan-details`,
  ADMIN_POST_PLAN_DETAILS_API: `${API_BASE_URL}/plan-details/save`,

  ADMIN_USER_MANAGEMENT_API: `${API_BASE_URL}/user-management`,

  ADMIN_GET_ALL_PAYMENT_HISTORY: `${API_BASE_URL}/user-management/payment-transactions`,

  ADMIN_DASHBOARD: `${API_BASE_URL}`,
  STRIPE_PUBLISHABLE_KEY:
    "pk_live_51RTCDVRwMXdgS3NcPfeLVoXiqmlDugWwLfKvWQmFcaELj0Yd6Fto8osJvb1qkShxeIWnKsk2q6X1uot8rZqKgJ8r00wiVtQwz6"
};

// Stripe/Payments endpoints used by the admin panel flows
// Adjust paths as needed to match your backend
AppConstants.PAYMENTS_SETUP_INTENT_API = `${API_BASE_URL}/payment-methods/setup-intent`;
// Prefer the consolidated payment-methods endpoint for saving
AppConstants.PAYMENTS_ADD_PAYMENT_METHOD_API = `${API_BASE_URL}/payment-methods`;
AppConstants.PAYMENTS_LIST_METHODS_API = `${API_BASE_URL}/payment-methods`;
AppConstants.PAYMENTS_DELETE_METHOD_API = `${API_BASE_URL}/payment-methods`;
AppConstants.PAYMENTS_SET_DEFAULT_METHOD_API = `${API_BASE_URL}/payment-methods/set-default`;
AppConstants.PAYMENTS_MAKE_PAYMENT_API = `${API_BASE_URL}/api/payments/make-payment`;
// Subscription endpoints
// AppConstants.SUBSCRIPTION_PREFILL_API = `${API_BASE_URL}/subscription/prefill`;
AppConstants.SUBSCRIPTION_CREATE_API = `${API_BASE_URL}/subscription`;
// Driver profile (to resolve customerId for subscription body)
AppConstants.DRIVER_PROFILE_API = `${API_BASE_URL}/profile`;

export default AppConstants;
